import { useState } from 'react';
import { LogoMark } from '../components/Logo';

const BASE = '/api';

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ user: '', pass: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BASE}/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: form.user, password: form.pass }),
      });
      if (!res.ok) {
        const err = await res.json();
        setError(err.error || 'Invalid credentials');
        return;
      }
      const data = await res.json();
      localStorage.setItem('pf_auth', data.role);
      localStorage.setItem('pf_client_id', data.client_id || '');
      localStorage.setItem('pf_client_name', data.client_name || '');
      localStorage.setItem('pf_username', data.username || '');
      localStorage.setItem('pf_token', data.token || '');
      onLogin(data.role, data.client_id, data.client_name);
    } catch(e) {
      setError('Connection error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ color: 'var(--text)', display: 'flex', justifyContent: 'center', marginBottom: 14 }}><LogoMark size={64} /></div>
          <div dir="ltr" style={{ fontFamily: 'var(--font-brand)', fontSize: 28, fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.02em' }}>Physio<span style={{ color: 'var(--primary)' }}>Fix</span></div>
          <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 4 }}>نظام الصيانة والإصلاح · Repair System</div>
        </div>
        <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 28, boxShadow: 'var(--shadow-md)' }}>
          <form onSubmit={submit}>
            <div className="field">
              <label>Username</label>
              <input className="input" value={form.user} onChange={e => setForm(f => ({ ...f, user: e.target.value }))} placeholder="Enter username" autoFocus />
            </div>
            <div className="field">
              <label>Password</label>
              <input className="input" type="password" value={form.pass} onChange={e => setForm(f => ({ ...f, pass: e.target.value }))} placeholder="Enter password" />
            </div>
            {error && <div style={{ color: 'var(--red)', fontSize: 13, marginBottom: 12, padding: '8px 12px', background: 'var(--red-dim)', borderRadius: 6 }}>{error}</div>}
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: 11 }} type="submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
